<template>
  <section class="container fader">
    <div class="row">
      <div class="col-md-4">


      </div>
      <div class="col-md-8">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <h3>Fast, performant, secure webapps</h3>
              <span>John Doe</span>
            </div>
            <div class="carousel-item">
              <h3>Fast, performant, secure webapps</h3>
              <span>John Doe</span>
            </div>
            <div class="carousel-item">
              <h3>Fast, performant, secure webapps</h3>
              <span>John Doe</span>
            </div>
          </div>

          <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FaderComp",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

.carousel-item {
  color:white;
}
</style>
